












































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import PrecificacaoModel from "@/models/cadastros/saude/PrecificacaoModel";
import { saudePrecificacaoService } from "@/service/cadastro/saude/precificacao/SaudePrecificacaoService";
import { saudeCidadeService } from "@/service/cadastro/saude/cidade/SaudeCidadeService";
import { saudeEspecialidadeService } from "@/service/cadastro/saude/especialidade/SaudeEspecialidadeService";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { estadosList, EstadoModel } from "@/models/commons/EstadoModel";
import { tiposFeriadosList } from "@/models/cadastros/saude/TipoFeriadoModel";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import { CidadeModel } from "@/models/commons/CidadeModel";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import EspecialidadeAutocomplete from "@/components/saude/EspecialidadeAutocomplete.vue";
import PrecificacaoFiltro from "@/models/cadastros/saude/PrecificacaoFiltro";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
    GsModalDialog,
    EspecialidadeAutocomplete
  }
})
export default class CadastroPrecificacao extends Vue {
  $refs!: {
    precoObserver: InstanceType<typeof ValidationObserver>;
  };
  
  preco: PrecificacaoModel = {
    id: undefined,
    cidade: undefined,
    especialidade: undefined,
    precoAssociado: undefined,
  };
  minPrice: number = 0;

  moneyMaskProperties = moneyMaskProperties;

  mostrarSelectEspecialidade = true;
  estados = estadosList;
  cidades: Array<CidadeModel> = [];
  estado?: EstadoModel = {
    sigla: "",
    nome: "",
  };
  especialidades?: EspecialidadeModel[] = [];


  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;

  created() {
    this.loadInfo();
  }

  @Watch("estado")
  obterCidades() {
    if (!this.isEdit) {
      saudeCidadeService
        .obterCidadesPorEstado(this.estado?.sigla)
        .then((res) => {
          this.cidades = res;
        });
    }
  }

  @Watch("preco.cidade")
  @Watch("preco.especialidade")
  verificarCadastro() {
    if (!this.isEdit && this.isSetCidade && this.isSetEspecialidade) {
      const filtro: PrecificacaoFiltro = {
        cidade: this.preco.cidade,
        especialidade: this.preco.especialidade,
      };
      saudePrecificacaoService
        .pesquisar(filtro, { itemsPerPage: 10 })
        .then((res) => {
          if (res.totalElements > 0) {
            this.openDialog('info', 'Atenção', 'Encontramos uma configuação para a cidade e especialidade selecionada. Alterando para o modo de edição.');
            this.preco.id = res.content[0].id;
            this.preco.precoAssociado = res.content[0].precoAssociado;
          }
        });
    }
  }

  get isSetCidade() {
    return this.preco.cidade && (this.preco.cidade.id || 0) > 0;
  }

  get isSetEspecialidade() {
    return this.preco.especialidade && (this.preco.especialidade.id || 0) > 0;
  }

  gravar() {
    this.$refs.precoObserver.validate().then((valid) => {
      if (valid) {
        if (this.isEdit) {
          this.preco.especialidade = {
            id: this.preco.especialidade?.id,
            nome: this.preco.especialidade?.nome
          }
          saudePrecificacaoService
            .atualizar(
              this.preco,
              new Number(this.preco.id)
            )
            .then((res: any) => {
              this.openDialog('success', 'Alterado', 'Alteração realizada com sucesso');
            })
            .catch((err: any) => {
              this.openDialog('error', 'Erro', err);
            });
        } else {
          saudePrecificacaoService
            .salvar(this.preco)
            .then((res) => {
              this.openDialog('success', 'Cadastrado', 'Cadastro realizado com sucesso');
            })
            .catch((err) => {
              this.openDialog('error', 'Erro', err.message);
            });
        }
      }
    });
  }

  get isEdit() {
    return !!this.preco.id;
  }

  async loadInfo() {
    if (this.$route.params.idPrecificacao) {
      this.loading = true;
      const precoDTO = await saudePrecificacaoService.obterPrecoPorId(
        new Number(this.$route.params.idPrecificacao)
      );

      const cidade = await saudeCidadeService.obterPorId(precoDTO.idCidade);

      this.preco = {
        id: precoDTO.id,
        especialidade: precoDTO.especialidade,
        cidade,
        precoAssociado: precoDTO.precoAssociado.toFixed(2),
      };
      this.estado = this.estados.find(
        (estado) => estado.sigla == precoDTO.estado
      );
      this.preco.especialidade = {
        id: precoDTO.especialidade.id,
        nome: precoDTO.especialidade.nome,
      };
      this.loading = false;
    } else {
      this.mostrarSelectEspecialidade = false;
    }
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
    if (this.dialogType == 'success') {
      this.$router.push({ name: "ListaPrecificacoesSaude" });
    }
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
